import * as React from 'react';
import { SVGProps } from 'react';

const SvgBath = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M8 6.25a3.25 3.25 0 0 1 6.5 0"
    />
    <path d="m12.885 14.851-.594-1.031a5.824 5.824 0 0 1 2.115-7.954 5.829 5.829 0 0 1 7.954 2.116l.6 1.031-10.075 5.838Z" />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m12.885 14.851-.594-1.031a5.824 5.824 0 0 1 2.115-7.954 5.829 5.829 0 0 1 7.954 2.116l.6 1.031-10.075 5.838ZM8 6v13m-2.7 4.115c.002 2.754 1.06 5.394 2.943 7.34 1.882 1.948 4.434 3.043 7.095 3.045h8.924c2.66-.004 5.212-1.099 7.094-3.046 1.882-1.946 2.94-4.586 2.944-7.339V18.5"
    />
    <path
      fill={props.fill}
      d="M4.375 18.431v4.731l26.143.024 4.764-4.755H4.375Z"
    />
    <path
      fill="currentColor"
      d="M30.523 6.432a4.754 4.754 0 1 0 0 9.508 4.754 4.754 0 0 0 0-9.508Zm2.192 7.435L29.572 11.7V8.106h1.902v2.606l2.32 1.602-1.079 1.554Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m10.47 36.47 3-3m13.061-.3 3 3"
    />
  </svg>
);

export default SvgBath;
